import React from "react";
import { Pagination } from "../pagination";
import HeaderTable from "./HeaderTable";

export interface FormatFieldProps {
  format: {
    displayName: string;
    fieldMatch: "customField" | string;
    customeField?: boolean;
    className?: string;
    sortKey?: string
    fullRow?: boolean
  }[];
  items: any[];
}

interface TableBlueprintProps {
  headerChild?: React.ReactNode;
  footerChild?: React.ReactNode;
  tableTemplate:
    | "table table-striped table-lightfont dataTable"
    | "table table-bordered table-lg table-v2 table-striped dataTable"
    | "table table-padded";
  renderList: FormatFieldProps;
  customField?: any;
  onSort?: (e: { key: string; direction: "ASC" | "DESC" }) => void;
  sort?: { key: string; direction: "ASC" | "DESC" };
  offset: any;
  setOffset: any;
  totalPage: number;
  limitDisplay?: number;
  pagination?: boolean;
  limit: number;
  setLimit: any;
}

export class TableBlueprint extends React.Component<TableBlueprintProps> {
  state: {
    sort: string;
    sortDirection: "sorting_asc" | "sorting_desc";
    displayColumn: any[];
    offset: number;
  };

  constructor(props: TableBlueprintProps) {
    super(props);
    const localStorageDisplay = localStorage.getItem(window.location.pathname);
    const displayColumn = localStorageDisplay
      ? JSON.parse(localStorageDisplay)
      : this.props.renderList.format
          .filter(
            (x, i) =>
              i < (this.props.limitDisplay ? this.props.limitDisplay : 4)
          )
          .map((x, index) => {
            return {
              label: x.displayName,
              value: index
            };
          });

    this.state = {
      sort: this.props.sort?.key!,
      sortDirection:
        this.props.sort?.direction === "ASC" ? "sorting_asc" : "sorting_desc",
      displayColumn: displayColumn.map((x: any, i: number)=>{
        return {
          ...x
        }
      }),
      offset: Number(new URLSearchParams(window.location.search).get("page")),
    };

    localStorage.setItem(
      window.location.pathname,
      JSON.stringify(displayColumn)
    );
  }

  async handleSort(key: string) {
    if (key === this.state.sort) {
      await this.setState({
        sortDirection:
          this.state.sortDirection === "sorting_asc"
            ? "sorting_desc"
            : "sorting_asc",
      });
    } else {
      await this.setState({
        sort: key,
        sortDirection: "sorting_asc",
      });
    }

    await this.props.onSort!({
      key,
      direction: this.state.sortDirection === "sorting_asc" ? "ASC" : "DESC",
    });
  }

  renderBody() {
    return (
      <tbody id="table_blueprint">
        {this.props.renderList.items.map((item, index) => {
          return (
            <tr key={index}>
              <td className="text-center">{index + 1}</td>
              {this.state.displayColumn.map((x) => {
                const res = this.props.renderList.format[x.value];
                if (res) {
                  return (
                    <td key={x.label} className={res.className}>
                      {res.customeField === true
                        ? this.props.customField[res.fieldMatch](
                            item[res.fieldMatch]
                          )
                        : item[res.fieldMatch]}
                    </td>
                  );
                }
                return (<></>)
              })}
            </tr>
          );
        })}
      </tbody>
    );
  }

  renderHeader() {
    return <>{this.props.headerChild && this.props.headerChild}</>;
  }

  renderFooter() {
    return (
      <>
        {this.props.footerChild && (
          <div className="row">
            <div className="col-sm-12">{this.props.footerChild}</div>
          </div>
        )}
      </>
    );
  }

  render() {
    const headers = [];

    for (const x of this.state.displayColumn) {
      const res = this.props.renderList.format[x.value];
      if (res !== undefined) {
        headers.push({
          label: x.label,
          className: res.className ? res.className : "",
          sortKey: res.sortKey!,
        });
      }
    }

    return (
      <div className="table-responsive">
        <div
          id="dataTable1_wrapper"
          className="dataTables_wrapper container-fluid dt-bootstrap4"
        >
          {this.renderHeader()}
          <div className="row">
            <div className="col-sm-12">
              <table className={this.props.tableTemplate}>
                {headers && (
                  <HeaderTable
                    {...this.props}
                    options={this.props.renderList.format.map((x, index) => {
                      return {
                        label: x.displayName,
                        value: index,
                      };
                    })}
                    select={this.state.displayColumn}
                    setSelect={(e: any) => {
                      localStorage.setItem(
                        window.location.pathname,
                        JSON.stringify(e)
                      );
                      this.setState({ displayColumn: e });
                    }}
                    items={headers}
                    sort={this.state.sort}
                    sortDirection={this.state.sortDirection}
                    handleSort={(key) => this.handleSort(key)}
                    offset={this.props.offset}
                    setOffset={this.props.setOffset}
                    totalPage={this.props.totalPage}
                  />
                )}
                {this.props.pagination === false ? (
                  <tfoot></tfoot>
                ) : (
                  <tfoot>
                    <tr>
                      <th
                        colSpan={this.state.displayColumn.length + 1}
                        style={{ padding: 12 }}
                      >
                        <Pagination
                          props={this.props}
                          offset={this.props.offset}
                          setOffset={this.props.setOffset}
                          total={this.props.totalPage}
                          display="FLEX"
                          limit={this.props.limit}
                          setLimit={this.props.setLimit}
                        />
                      </th>
                    </tr>
                  </tfoot>
                )}
                {this.renderBody()}
              </table>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}
